module.exports = __webpack_public_path__ + "img/add-image3.82603cf3.png";